import React, { useEffect, useState } from "react";
import { ACTIONS } from "../../../../constants/Constants";
import { t } from "i18next";
import CustomCheckBox from "../../../Hospital/components/HeaderFileChecks/CustomCheckBox";
import { ComboBox, ChoiceGroup, SelectableOptionMenuItemType } from "@fluentui/react";
import { getEnv } from '../../../../helpers/EnvHelper';

const choiceGroupStyles = {
  label: {
    display: "inline",
  },
  flexContainer: {
    columnGap: "1em",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};

const OtherSettings = (props) => {
  let isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM")=="true"||getEnv("REACT_APP_VDC_PLATFORM")==true)?true:false;
  let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM")=="true"||getEnv("REACT_APP_BVP_PLATFORM")==true)?true:false;

  const [qcEnabled, setQcEnabled] = useState(
    props.values.qcEnabled || props.values.preliminaryQcEnabled
  );
  const [preliminaryQcEnabled, setPreliminaryQcEnabled] = useState(
    !!props.values.preliminaryQcEnabled
  );
  const [autoAssignEnabled, setAutoAssignEnabled] = useState(
    props.values.autoAssignEnable
  );
  const [historyAvailable, setHistoryAvailable] = useState(
    props.values.historyAvailable
  );

  const [firmEnableUnassignmentService, setFirmEnableUnassignmentService] = useState(props.values.firmEnableUnassignmentService)

  const [clinicalNoteMandatory, setClinicalNoteMandatory] = useState(
    props.values.clinicalNoteMandatory
  );

  const [technicianContactMandatory, setTechnicianContactMandatory] = useState(
    props.values.technicianContactMandatory
  );

  const [selectedModality, setSelectedModality] = useState(
    props.values.modalityIds
  );
  const [selectedAutoAssignModality, setSelectedAutoAssignModality] = useState(
    props.values.autoAssignModalityIds
  );
  const [selectedHistoryModality, setSelectedHistoryModality] = useState(
    props.values.historyModalityIds
  );

  const [selectedUnassignmentModality, setSelectedUnassignmentModality] = useState(
    (props.values.unassignmentModalityIds && Array.isArray(props.values.unassignmentModalityIds)) 
      ? props.values.unassignmentModalityIds 
      : []
  );


  const [modalityList, setModalityList] = useState([]);
  const [historyModalityList, setHistoryModalityList] = useState([]);

  useEffect(() => {
    let mdl = props.modalityList.map((m) => {
      return {
        key: m.id + "",
        text: m.name,
      };
    });
    setModalityList(mdl);

    let hmdl = props.historyModalityList.map((m) => {
      return {
        key: m.id + "",
        text: m.name,
      };
    });
    setHistoryModalityList(hmdl);
  }, []);

  const getModalityNames = (modalityIds) => {
    let modalityNames = [];
    if (!modalityIds || !Array.isArray(modalityIds)) {
    return "";
  }
    modalityNames = props.modalityList
      .filter((m) => modalityIds.includes("" + m.id))
      .map((modality) => modality.name);
    return modalityNames.join(", ");
  };

  const getHistoryModalityNames = (modalityIds) => {
    let modalityNames = [];
    modalityNames = props.historyModalityList
      .filter((m) => modalityIds.includes("" + m.id))
      .map((modality) => modality.name);
    return modalityNames.join(", ");
  };

  useEffect(() => {
    props.values.autoAssignModalityIds = selectedAutoAssignModality;
  }, [selectedAutoAssignModality]);

  useEffect(() => {;
    props.values.modalityIds = selectedModality;
  }, [selectedModality]);

  useEffect(() => {
    props.values.historyModalityIds = selectedHistoryModality;
  }, [selectedHistoryModality])

  useEffect(() => {
  props.values.unassignmentModalityIds = selectedUnassignmentModality.length > 0 
    ? selectedUnassignmentModality 
    : [];
  }, [selectedUnassignmentModality]);

  // In OtherSettings.jsx, modify the useEffect:
  return (
    <>
      <div className="tab-section">
        {props.action === ACTIONS.EDIT && (
          <>
            <div className="ms-Grid" dir="ltr">
              <section className="sectionA">
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    padding: "0px 0px",
                  }}
                >
                  {t("hospital.qc-settings")}
                </p>
              </section>
              <div
                style={{ display: "flex", maxHeight: "40px", marginTop: "5px" }}
              >
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-quality-check")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.qcEnabled || props.values.preliminaryQcEnabled}
                      onChangeCustom={() => {
                        const newValue = !(
                          props.values.qcEnabled || props.values.preliminaryQcEnabled
                        );
                        setQcEnabled(newValue);
                        if (!newValue) {
                          props.values.qcEnabled = false;
                          props.values.preliminaryQcEnabled = false;
                          setPreliminaryQcEnabled(false);
                          props.values.twoSignaturesAllowed = false;
                          props.values.enableQCAutoAssignment = false;
                          setSelectedModality([]);
                        } else {
                          props.values.qcEnabled = true;
                          props.values.preliminaryQcEnabled = false;
                          setPreliminaryQcEnabled(false);
                          props.values.twoSignaturesAllowed = false;
                          props.values.enableQCAutoAssignment = true;
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              {qcEnabled && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      minHeight: "40px",
                      marginTop: "5px",
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.qc-type")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }} className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg8 ms-xl12">
                        <ChoiceGroup
                          options={[
                            { key: "final", text: t("hospital.final-qc") },
                            { key: "preliminary", text: t("hospital.preliminary-qc") },
                          ]}
                          selectedKey={
                            preliminaryQcEnabled ? "preliminary" : "final"
                          }
                          onChange={(ev, option) => {
                            if (option?.key === "preliminary") {
                              props.values.qcEnabled = false;
                              props.values.preliminaryQcEnabled = true;
                              setPreliminaryQcEnabled(true);
                            } else {
                              props.values.qcEnabled = true;
                              props.values.preliminaryQcEnabled = false;
                              setPreliminaryQcEnabled(false);
                            }
                          }}
                          styles={{
                            flexContainer: { display: "flex", gap: "20px" },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      maxHeight: "40px",
                      marginTop: "5px",
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.allow-two-signatures")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.twoSignaturesAllowed}
                          onChangeCustom={() => {
                            props.values.twoSignaturesAllowed =
                              !props.values.twoSignaturesAllowed;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex", maxHeight: "60px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.modality")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                      <div
                        style={{
                          paddingLeft: "8px",
                          marginTop: "5px",
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <ComboBox
                          selectedKey={selectedModality}
                          placeholder="Select Modality"
                          options={[...modalityList]}
                          multiSelect
                          calloutProps={{ doNotLayer: true }}
                          onChange={(e, option) => {
                            let selected = option?.selected;
                            if (option) {
                              setSelectedModality((prevSelectedKeys) =>
                                selected
                                  ? [...prevSelectedKeys, option.key]
                                  : prevSelectedKeys.filter(
                                      (k) => k !== option.key
                                    )
                              );
                            }
                          }}
                          errorMessage={
                            props.errorState?.modalityIds?.error &&
                            props.errorState?.modalityIds?.msg
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      maxHeight: "40px",
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.enable-qc-auto-assignment")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.enableQCAutoAssignment}
                          onChangeCustom={() => {
                            props.values.enableQCAutoAssignment =
                              !props.values.enableQCAutoAssignment;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* <section className="sectionA"  style={{marginTop: "1.5rem"}}>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    padding: "0px 0px",
                  }}
                >
                  {t("hospital.auto-assign-settings")}
                </p>
              </section>
              <div style={{ display: "flex", maxHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-auto-assignment")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.autoAssignEnable}
                      onChangeCustom={() => {
                        setAutoAssignEnabled((prev) => !prev);
                        props.values.autoAssignEnable =
                          !props.values.autoAssignEnable;
                      }}
                    />
                  </div>
                </div>
              </div>

              {!!autoAssignEnabled && (
                <div style={{ display: "flex", maxHeight: "60px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                    <p className="single-line-form-field-key">
                      {t("hospital.modality")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                    <div
                      style={{
                        paddingLeft: "8px",
                        marginTop: "5px",
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <ComboBox
                        selectedKey={selectedAutoAssignModality}
                        placeholder="Select Modality"
                        options={[
                          { key: "selectAll", text: "Select All", itemType: SelectableOptionMenuItemType.SelectAll},
                          ...modalityList,
                        ]}
                        multiSelect
                        calloutProps={{ doNotLayer: true }}
                        onChange={(e, option) => {
                          console.log(option);
                          const selected = option?.selected;
                          const currentSelectedOptionKeys =
                            selectedAutoAssignModality.filter(
                              (key) => key !== "selectAll"
                            );
                          const selectAllState =
                            currentSelectedOptionKeys.length ===
                            modalityList.length;

                          if (option) {
                            if (option?.key === "selectAll") {
                              selectAllState
                                ? setSelectedAutoAssignModality([])
                                : setSelectedAutoAssignModality([
                                    ...modalityList.map((o) => o.key),
                                  ]);
                            } else {
                              const updatedKeys = selected
                                ? [...currentSelectedOptionKeys, option.key]
                                : currentSelectedOptionKeys.filter(
                                    (k) => k !== option.key
                                  );
                              if (updatedKeys.length === modalityList.length) {
                                // updatedKeys.push('selectAll');
                              }
                              setSelectedAutoAssignModality(updatedKeys);
                            }
                          }
                        }}
                        errorMessage={
                          props.errorState?.autoAssignModalityIds?.error &&
                          props.errorState?.autoAssignModalityIds?.msg
                        }
                      />
                    </div>
                  </div>
                </div>
              )} */}

              <section className="sectionA" style={{marginTop: "1.5rem"}}>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    padding: "0px 0px",
                  }}
                >
                  {t("hospital.history-settings")}
                </p>
              </section>
              <div style={{ display: "flex", maxHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                  <p className="single-line-form-field-key">
                    {t("hospital.history-available")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.historyAvailable}
                      onChangeCustom={() => {
                        // setHistoryAvailable((prev) => !prev);
                        // props.values.historyAvailable = !props.values.historyAvailable;
                        const newValue = !props.values.historyAvailable;
                        console.log("new Value", newValue);
                        setHistoryAvailable(newValue);
                        props.values.historyAvailable = newValue;

                        if (!newValue) {
                          props.values.clinicalNoteMandatory = false;
                          props.values.subModalityMandatory = false;
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              {historyAvailable && (
                <>
                  <div style={{ display: "flex", maxHeight: "60px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.modality")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                      <div
                        style={{
                          paddingLeft: "8px",
                          marginTop: "5px",
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <ComboBox
                          selectedKey={selectedHistoryModality}
                          placeholder="Select Modality"
                          options={[...historyModalityList]}
                          multiSelect
                          calloutProps={{ doNotLayer: true }}
                          onChange={(e, option) => {
                            let selected = option?.selected;
                            if (option) {
                              setSelectedHistoryModality((prevSelectedKeys) =>
                                selected
                                  ? [...prevSelectedKeys, option.key]
                                  : prevSelectedKeys.filter(
                                      (k) => k !== option.key
                                    )
                              );
                            }
                          }}
                          errorMessage={
                            props.errorState?.historyModalityIds?.error &&
                            props.errorState?.historyModalityIds?.msg
                          }
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

{historyAvailable && (
                <>
                  <div
                    style={{
                      display: "flex",
                      maxHeight: "40px"
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.clinical-note-mandatory")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.clinicalNoteMandatory}
                          onChangeCustom={() => {
                            props.values.clinicalNoteMandatory =
                              !props.values.clinicalNoteMandatory;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

{historyAvailable && !isVdcPlatform && (
                <>
                  <div
                    style={{
                      display: "flex",
                      maxHeight: "40px"
                    }}
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                      <p className="single-line-form-field-key">
                        {t("hospital.sub-modality-mandatory")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div style={{ marginTop: "5px" }}>
                        <CustomCheckBox
                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                          values={props.values.subModalityMandatory}
                          onChangeCustom={() => {
                            props.values.subModalityMandatory =
                              !props.values.subModalityMandatory;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div style={{ display: "flex", maxHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                  <p className="single-line-form-field-key">
                    {t("hospital.technician-contact-mandatory")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div style={{ marginTop: "5px" }}>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.technicianContactMandatory}
                      onChangeCustom={() => {
                            props.values.technicianContactMandatory =
                              !props.values.technicianContactMandatory;
                          }}
                    />
                  </div>
                </div>
              </div>
                <>
<section className="sectionA" style={{marginTop: "1.5rem"}}>
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  padding: "0px 0px",
                }}
              >
                {t("hospital.unassignment-settings")}
              </p>
            </section>
            <div style={{ display: "flex", maxHeight: "40px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                <p className="single-line-form-field-key">
                  {t("hospital.enable-unassignment-service")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.firmEnableUnassignmentService}
                    onChangeCustom={() => {
                      const newValue = !props.values.firmEnableUnassignmentService;
                      setFirmEnableUnassignmentService(newValue);
                      props.values.firmEnableUnassignmentService = newValue;
                      
                      if (!newValue) {
                         console.log("Clearing selected modalities because disabled");
                        setSelectedUnassignmentModality([]);
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            {firmEnableUnassignmentService && (
              <div style={{ display: "flex", maxHeight: "60px", marginTop: "5px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3" style={{marginTop:"15px"}}>
                  <p className="single-line-form-field-key">
                    {t("hospital.selected-modality-for-unassignment")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4 single-line-form-field-value">
                  <div
                    style={{
                      paddingLeft: "8px",
                      marginTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <ComboBox
                      selectedKey={selectedUnassignmentModality}
                      placeholder={t("hospital.select-modality")}
                      options={[...modalityList]}
                      multiSelect
                      calloutProps={{ doNotLayer: true }}
                      onChange={(e, option) => {
                        let selected = option?.selected;
                        if (option) {
                          setSelectedUnassignmentModality((prevSelectedKeys) => {
                            const newSelection = selected
                              ? [...prevSelectedKeys, option.key]
                              : prevSelectedKeys.filter((k) => k !== option.key);
                            return newSelection;
                          });
                        }
                      }}
                      errorMessage={
                        props.errorState?.unassignmentModalityIds?.error &&
                        props.errorState?.unassignmentModalityIds?.msg
                      }
                    />
                  </div>
                </div>
              </div>
            )}
            </>




            </div>
          </>

          
        )}
        {props.action === ACTIONS.VIEW && (
          <>
            <div className="ms-Grid" dir="ltr">
              <section className="sectionA" style={{marginBottom: "1rem"}}>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    padding: "0px 0px",
                  }}
                >
                  {t("hospital.qc-settings")}
                </p>
              </section>
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-quality-check")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>
                    {props.values.qcEnabled || props.values.preliminaryQcEnabled
                      ? "Yes"
                      : "No"}
                  </div>
                </div>
              </div>
              {!!qcEnabled && (
                <>
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.qc-type")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>
                        {props.values.preliminaryQcEnabled
                          ? t("hospital.preliminary-qc")
                          : t("hospital.final-qc")}
                      </div>
                    </div>
                  </div>
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.allow-two-signatures")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>
                        {props.values.twoSignaturesAllowed ? "Yes" : "No"}
                      </div>
                    </div>
                  </div>
                  {/* add modality ids part */}
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.modality")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>{getModalityNames(props.values.modalityIds)}</div>
                    </div>
                  </div>

                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.enable-qc-auto-assignment")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                      <div>
                        {props.values.enableQCAutoAssignment ? "Yes" : "No"}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* <section className="sectionA" style={{margin: "1rem 0"}}>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    padding: "0px 0px",
                  }}
                >
                  {t("hospital.auto-assign-settings")}
                </p>
              </section>
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-auto-assignment")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.autoAssignEnable ? "Yes" : "No"}</div>
                </div>
              </div>
              {!!autoAssignEnabled && (
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">{t("hospital.modality")}</div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                    <div>
                      {getModalityNames(props.values.autoAssignModalityIds)}
                    </div>
                  </div>
                </div>
              )} */}

              <section className="sectionA" style={{margin: "1rem 0"}}>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    padding: "0px 0px",
                  }}
                >
                  {t("hospital.history-settings")}
                </p>
              </section>
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.history-available")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.historyAvailable ? "Yes" : "No"}</div>
                </div>
              </div>
              {!!historyAvailable && (
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">{t("hospital.modality")}</div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                    <div>
                      {getHistoryModalityNames(props.values.historyModalityIds)}
                    </div>
                  </div>
                </div>
              )}
              {!!historyAvailable && (
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">{t("hospital.clinical-note-mandatory")}</div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                    <div>
                      {props.values.clinicalNoteMandatory ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
              )}
              {!!historyAvailable && (
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">{t("hospital.sub-modality-mandatory")}</div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                    <div>
                      {props.values.subModalityMandatory ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
              )}
              {(
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">{t("hospital.technician-contact-mandatory")}</div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                    <div>
                      {props.values.technicianContactMandatory ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
              )}

              <>
              <section className="sectionA" style={{margin: "1rem 0"}}>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    padding: "0px 0px",
                  }}
                >
                  {t("hospital.unassignment-settings")}
                </p>
              </section>
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-unassignment-service")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                  <div>{props.values.firmEnableUnassignmentService ? "Yes" : "No"}</div>
                </div>
              </div>
              {props.values.firmEnableUnassignmentService && (
                <div className="ms-Grid-row" style={{ minHeight: "40px", marginTop: "10px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      {t("hospital.modality")}
                    </div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                    <div>{getModalityNames(props.values.unassignmentModalityIds)}</div>
                  </div>
                </div>
              )}
              </>

            </div>
          </>
        )}
      </div>
    </>
  );
};

export default OtherSettings;
